import {
  SET_SHOPPING_ICON_ELEMENT_FILE_INFO,
  SET_SHOPPING_ICON_ELEMENT_ICON_SIZE,
  SET_SHOPPING_ICON_ELEMENT_ICON_COLOR,
  SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR,
} from './action-names';

export function setShoppingIconElementFileInfo(data) {
  return {
    type: SET_SHOPPING_ICON_ELEMENT_FILE_INFO,
    ...data
  };
};

export function setShoppingIconElementIconSize(data) {
  return {
    type: SET_SHOPPING_ICON_ELEMENT_ICON_SIZE,
    ...data
  };
};

export function setShoppingIconElementIconColor(data) {
  return {
    type: SET_SHOPPING_ICON_ELEMENT_ICON_COLOR,
    ...data
  };
};

export function setShoppingIconElementTextColor(data) {
  return {
    type: SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/shopping-icon-element-actions.js